import type { Component, ComputedRef } from 'vue';

export enum INPUT_MAPPING_SOURCE {
  GDV = 'GDV',

  INVENTORY_CONTRACT = 'Bestandsvertrag',
  // client sources
  VERSICHERUNGSNEHMER = 'versicherungsnehmer',
}

export const InputMappingSourceLabel: Record<INPUT_MAPPING_SOURCE, string> = {
  [INPUT_MAPPING_SOURCE.GDV]: 'GDV',
  [INPUT_MAPPING_SOURCE.VERSICHERUNGSNEHMER]: 'Kundenakte',
  [INPUT_MAPPING_SOURCE.INVENTORY_CONTRACT]: 'Bestandsvertrag',
};

// Client overrides GDV overrides inventory contract
export const InputMappingPriority = [
  INPUT_MAPPING_SOURCE.VERSICHERUNGSNEHMER,
  INPUT_MAPPING_SOURCE.GDV,
  INPUT_MAPPING_SOURCE.INVENTORY_CONTRACT,
];

export type InputFieldPath = string;

export type InputMappingData = Record<InputFieldPath, InputMappingValue>;

export type InputMappingPathValue =
  | string
  | number
  | null
  | boolean
  | undefined;

export interface InputMappingInformation {
  value: InputMappingPathValue;
  hint: null | string;
  valueReplacementText: null | string;
}

export type InputMappingFieldDefinition = Record<
  InputFieldPath,
  InputMappingInformation
>;

export interface InputMappingBackendResponse {
  sources: {
    [key in INPUT_MAPPING_SOURCE]?: {
      name: INPUT_MAPPING_SOURCE;
      fields: {
        searchData?: {
          eingabedaten: InputMappingFieldDefinition;
        };
        contractData?: InputMappingFieldDefinition;
        clientData?: InputMappingFieldDefinition;
      };
    };
  };
  bestandsvertrag?: {
    id: number;
    date: string;
  } | null;
}

export interface InputMappingStoreState {
  data: InputMappingData;
  invalidChoices: InputFieldPath[];
  isLoading: boolean;
  inventoryContract: InputMappingBackendResponse['bestandsvertrag'];
}

export enum INPUT_MAPPING_TARGET {
  INPUT = 'input',
  CONTRACT = 'contract',
  VERSICHERUNGSNEHMER = 'vn',
}

export interface InputMappingValue<
  T = string | number | boolean | null | undefined,
> {
  source: INPUT_MAPPING_SOURCE;
  value: T;
  hint: null | string;
  valueReplacementText: null | string;
  target: INPUT_MAPPING_TARGET;
}

export interface InputMappedData {
  single: InputMappingData;
  multi: InputMappingData;
  unknown: InputMappingData;
}

export interface InputMappingListProps {
  fields: Array<{
    path: string;
    suffix?: string;
    formatter?: (val: any) => string | unknown;
    isHidden?: ComputedRef<boolean>;
    isContractField?: boolean;
    label?: string; // useful for contract fields, since we cant access the actual label without rendering the form field
    allowedSources?: INPUT_MAPPING_SOURCE[]; // if not set, we only display GDV mappings
  }>;
}

export interface InputMappingGroup {
  icon: string;
  label: string;
  infos: Array<{
    component: Component;
    props: Record<string, unknown>;
    requiredPaths: string[];
    requiredOr?: boolean;
    noPadding?: boolean;
  }>;
}
